import * as TemplateTypes from 'types/template.types';
import BaseScene from 'src/scenes/base';

export default class DetuneAudioTransition extends TemplateTypes.AudioTransition {
    private enterTween?: Phaser.Tweens.Tween;
    private exitTween?: Phaser.Tweens.Tween;

    constructor(scene: BaseScene, track: Phaser.Sound.HTML5AudioSound | Phaser.Sound.WebAudioSound, config: TemplateTypes.BaseTransitionConfig = {}){
        super(scene, track, config);
    }

    get isPlaying(){
        return this.exitTween?.isPlaying || this.enterTween?.isPlaying;
    }

    enter(onComplete?: Function) : Promise<void> | undefined {
        if (this.isPlaying) return;
        if (!this.track.isPlaying) {
            this.track.volume = 0;
            this.track.detune = -1200;
            this.track.play();
        }

        let tweenTarget = { volume: 0, detune: -1200 }; //Use a proxy target because the tweens are too granular
        return new Promise((res, rej) => {
            this.scene.tweens.add({
                targets: tweenTarget,
                volume: 1,
                detune: 50,
                duration: this.config.duration ?? 500,
                onUpdate: () => {
                    this.track.detune = parseFloat(tweenTarget.detune.toFixed(2))
                    this.track.volume = parseFloat(tweenTarget.volume.toFixed(2))
                },
                onComplete: () => {
                    onComplete?.();
                    res();
                }
            });
        })
    }

    exit(onComplete?: Function) : Promise<void> | undefined {
        if (this.isPlaying) return;
        let tweenTarget = { volume: 1, detune: 50 }; //Use a proxy target because the tweens are too granular
        return new Promise((res, rej) => {
            this.scene.tweens.add({
                targets: tweenTarget,
                volume: 0,
                detune: -1200,
                duration: this.config.duration ?? 500,
                onUpdate: () => {
                    this.track.detune = parseFloat(tweenTarget.detune.toFixed(2));
                    this.track.volume = parseFloat(tweenTarget.volume.toFixed(2))
                },
                onComplete: () => {
                    this.track.stop();
                    onComplete?.();
                    res();
                }
            });
        })
    }

    cancel(){
        this.enterTween?.stop();
        this.exitTween?.stop();
    }

    destroy(){
        this.enterTween?.destroy();
        this.exitTween?.destroy();
    }
}
